import { useState } from 'react';
import { ErrorMessage, Field } from 'formik';
import Eyelock from '@/components/icons/eye-lock';
import EyeIcon from '@/components/icons/eye-icon';

const InputPassword = ({
  id,
  title,
  name,
  labelClassName = '',
  inputClassName = '',
  iconClassName = '',
  ...props
}) => {
  const [show, setShow] = useState(false);
  return (
    <div className='flex flex-col gap-1'>
      <label className={`max-lg:text-sm ${labelClassName}`} htmlFor={id}>
        {title} {props?.mandatory && <span className='text-red-600'>*</span>}
      </label>
      <div className='relative flex-1 rounded-lg border border-[#E4E4F9] px-2 py-1 outline-none lg:py-1.5'>
        <Field
          name={name}
          id={id}
          type={show ? 'text' : 'password'}
          className={`w-full outline-none max-lg:placeholder:text-sm max-md:text-[15px] max-md:placeholder:text-[15px] max-sm:text-sm max-sm:placeholder:text-sm ${inputClassName}`}
          {...props}
        />
        {!show ? (
          <Eyelock
            onClick={() => setShow(!show)}
            className={`absolute end-3 top-1/2 z-20 size-5 -translate-y-1/2 max-lg:size-5 ${iconClassName}`}
          />
        ) : (
          <EyeIcon
            onClick={() => setShow(!show)}
            className={`absolute end-3 top-1/2 z-20 size-5 -translate-y-1/2 max-lg:size-5 ${iconClassName}`}
          />
        )}
      </div>
      <ErrorMessage
        name={name}
        component='p'
        className='text-xs text-red-600 lg:text-sm'
      />
    </div>
  );
};

export default InputPassword;
